import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { Modal } from '../../components/Modal';

export type CreateSprintDialogProps = {
  readonly open: boolean;
  readonly name: string;
  readonly isPending: boolean;
  readonly onNameChange: (name: string) => void;
  readonly onClose: () => void;
  readonly onCreate: () => void;
};

/** Создание спринта (UC-SPR-01). */
export function CreateSprintDialog({
  open,
  name,
  isPending,
  onNameChange,
  onClose,
  onCreate,
}: CreateSprintDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Новый спринт"
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Отмена
          </Button>
          <Button variant="primary" loading={isPending} disabled={name.trim().length === 0} onClick={onCreate}>
            Создать
          </Button>
        </>
      }
    >
      <Input
        label="Название спринта"
        value={name}
        onChange={(event) => onNameChange(event.target.value)}
      />
    </Modal>
  );
}
